$(document).ready(function() {
    if(!window.dAgency) window.dAgency = {};

    window.dAgency.collectionCarouselSetup = $context => {
        if(!$context || !$context.length) $context = $('body');

        const setArrowsPosition = function(slick) {
            let $image_box = $(this).find(".product__image-wrapper");
            let $arrows = $(this).find("button.slick-arrow");

            $image_box_height = $image_box.innerHeight();
            $top = $image_box_height / 2;

            $arrows.css("top", $top);
        }

        const setupProxyLinks = function(slick) {
            const $slider = $(slick.target);
            const $proxyLinks = $slider.find('[data-link-proxy]');

            if($proxyLinks.length){
                $proxyLinks.off('click'); // Removing previous proxy link initialization

                $proxyLinks.ProxyLink({
                    excludes: ['.slick-dots', '.product-tile__variant', '.swym-add-to-wishlist-view-product' ]
                });
            }
        }

        $context.find('.slider-collection-4-wrapper, .slider-collection-6-wrapper').on('setPosition', setArrowsPosition);
        $context.find('.slider-collection-4-wrapper, .slider-collection-6-wrapper').on('init', function(slick){
            setupProxyLinks(slick);
            setArrowsPosition(slick);
        });

        const $sl4 = $context.find('.slider-collection-4-wrapper');

        if($sl4.length) {
            $sl4.not('.slick-initialized').slick({
            infinite: false,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            dots: true,
            prevArrow: false,
            nextArrow: false,
            responsive: [
                {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    prevArrow: false,
                    nextArrow: false,
                }
                }
            ]
            });
        }
    }

    window.dAgency.collectionCarouselSetup();
});
